export function trim(str) {
    return String.prototype.trim.call(str);
}

export function isType(arg, type) {
    return Object.prototype.toString.call(arg) === '[object ' + type + ']';
}

export function isWeixin() {
    return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1;
}

export function parseQuery() {
    const res = {};
    let url = location.href.replace('?utm_source=tokenpocket', '');
    const query = (url.split('?')[1] || '').trim().replace(/^(\?|#|&)/, '');

    if (!query) {
        return res;
    }

    query.split('&').forEach(param => {
        const parts = param.replace(/\+/g, ' ').split('=');
        const key = decodeURIComponent(parts.shift());
        const val = parts.length > 0 ? decodeURIComponent(parts.join('=')) : null;

        if (res[key] === undefined) {
            res[key] = val;
        } else if (Array.isArray(res[key])) {
            res[key].push(val);
        } else {
            res[key] = [res[key], val];
        }
    });

    return res;
}
export function sha1(string) {
    function rotateLeft(lValue, iShiftBits) {
        return (lValue << iShiftBits) | (lValue >>> (32 - iShiftBits));
    }

    function cvtHex(value) {
        var string = '';
        var i;
        var v;
        for (i = 7; i >= 0; i--) {
            v = (value >>> (i * 4)) & 0x0f;
            string += v.toString(16);
        }
        return string;
    }
    function uTF8Encode(string) {
        string = string.replace('/\x0d\x0a/g', '\x0a');
        var output = '';
        for (var n = 0; n < string.length; n++) {
            var c = string.charCodeAt(n);
            if (c < 128) {
                output += String.fromCharCode(c);
            } else if (c > 127 && c < 2048) {
                output += String.fromCharCode((c >> 6) | 192);
                output += String.fromCharCode((c & 63) | 128);
            } else {
                output += String.fromCharCode((c >> 12) | 224);
                output += String.fromCharCode(((c >> 6) & 63) | 128);
                output += String.fromCharCode((c & 63) | 128);
            }
        }
        return output;
    }
    var blockstart;
    var i, j;
    var W = new Array(80);
    var H0 = 0x67452301;
    var H1 = 0xefcdab89;
    var H2 = 0x98badcfe;
    var H3 = 0x10325476;
    var H4 = 0xc3d2e1f0;
    var A, B, C, D, E;
    var tempValue;
    string = uTF8Encode(string);
    var stringLength = string.length;
    var wordArray = new Array();
    for (i = 0; i < stringLength - 3; i += 4) {
        j =
            (string.charCodeAt(i) << 24) |
            (string.charCodeAt(i + 1) << 16) |
            (string.charCodeAt(i + 2) << 8) |
            string.charCodeAt(i + 3);
        wordArray.push(j);
    }
    switch (stringLength % 4) {
        case 0:
            i = 0x080000000;
            break;
        case 1:
            i = (string.charCodeAt(stringLength - 1) << 24) | 0x0800000;
            break;
        case 2:
            i =
                (string.charCodeAt(stringLength - 2) << 24) |
                (string.charCodeAt(stringLength - 1) << 16) |
                0x08000;
            break;
        case 3:
            i =
                (string.charCodeAt(stringLength - 3) << 24) |
                (string.charCodeAt(stringLength - 2) << 16) |
                (string.charCodeAt(stringLength - 1) << 8) |
                0x80;
            break;
    }
    wordArray.push(i);
    while (wordArray.length % 16 != 14) wordArray.push(0);
    wordArray.push(stringLength >>> 29);
    wordArray.push((stringLength << 3) & 0x0ffffffff);
    for (blockstart = 0; blockstart < wordArray.length; blockstart += 16) {
        for (i = 0; i < 16; i++) W[i] = wordArray[blockstart + i];
        for (i = 16; i <= 79; i++)
            W[i] = rotateLeft(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
        A = H0;
        B = H1;
        C = H2;
        D = H3;
        E = H4;
        for (i = 0; i <= 19; i++) {
            tempValue =
                (rotateLeft(A, 5) + ((B & C) | (~B & D)) + E + W[i] + 0x5a827999) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = tempValue;
        }
        for (i = 20; i <= 39; i++) {
            tempValue = (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0x6ed9eba1) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = tempValue;
        }
        for (i = 40; i <= 59; i++) {
            tempValue =
                (rotateLeft(A, 5) + ((B & C) | (B & D) | (C & D)) + E + W[i] + 0x8f1bbcdc) &
                0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = tempValue;
        }
        for (i = 60; i <= 79; i++) {
            tempValue = (rotateLeft(A, 5) + (B ^ C ^ D) + E + W[i] + 0xca62c1d6) & 0x0ffffffff;
            E = D;
            D = C;
            C = rotateLeft(B, 30);
            B = A;
            A = tempValue;
        }
        H0 = (H0 + A) & 0x0ffffffff;
        H1 = (H1 + B) & 0x0ffffffff;
        H2 = (H2 + C) & 0x0ffffffff;
        H3 = (H3 + D) & 0x0ffffffff;
        H4 = (H4 + E) & 0x0ffffffff;
    }
    tempValue = cvtHex(H0) + cvtHex(H1) + cvtHex(H2) + cvtHex(H3) + cvtHex(H4);
    return tempValue.toLowerCase();
}
export function resizePageFontSize() {
    var docEl = document.documentElement;
    setRemUnit();
    // reset rem unit on page resize
    window.addEventListener('resize', setRemUnit);
    window.addEventListener('pageshow', function(e) {
        if (e.persisted) {
            setRemUnit();
        }
    });

    // set 1rem = viewWidth / 10
    function setRemUnit() {
        var rem = docEl.clientWidth / 10;
        docEl.style.fontSize = rem + 'px';
    }
}
export function empty(value) {
    switch (typeof value) {
        case 'undefined':
            return true;
        case 'string':
            if (value.replace(/(^[ \t\n\r]*)|([ \t\n\r]*$)/g, '').length == 0) return true;
            break;
        case 'boolean':
            if (!value) return true;
            break;
        case 'number':
            if (value === 0 || isNaN(value)) return true;
            break;
        case 'object':
            if (value === null || value.length === 0) return true;
            for (const i in value) {
                return false;
            }
            return true;
    }
    return false;
}
/**
 * 时间戳转时间
 * @param {String} data
 */
export function formatDateTime(data) {
    let date = data ? new Date(data) : new Date();
    let YY = date.getFullYear() + '-';
    let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
    let hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    let mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    let ss = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
    return YY + MM + DD + ' ' + hh + mm + ss;
}
/**
 * 时间戳转日期
 * @param {*} data
 * @returns
 */
export function formatDate(data) {
    let date = data ? new Date(data) : new Date();
    let YY = date.getFullYear() + '-';
    let MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    let DD = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();

    return YY + MM + DD;
}
export function getDaysBetweenTwoDays(dateBegin, dateEnd) {
    let timeBegin = new Date(dateBegin),
        timeEnd = new Date(dateEnd);

    var dateDiff = timeEnd.getTime() - timeBegin.getTime(); //时间差的毫秒数
    var dayDiff = Math.ceil(dateDiff / (24 * 3600 * 1000)); //计算出相差天数
    return dayDiff + 1;
}

const VUE_APP_API_URL = process.env.VUE_APP_API_URL || `${location.origin}/api`;
const VUE_APP_WS_URL = process.env.VUE_APP_WS_URL || `ws:${location.hostname}:20003`;
const VUE_APP_SECRET = process.env.VUE_APP_SECRET || '';
const PREFIX = process.env.VUE_APP_PREFIX || '';

export { VUE_APP_API_URL, VUE_APP_WS_URL, VUE_APP_SECRET, PREFIX };
